// src/web/faceConstants.js
//
// Constants taken from MediaPipe's canonical face landmark topology.
//
// FACEMESH_FACE_OVAL — the 36 landmark indices that trace the outline of the
// face from forehead to chin and back. We use these to build a simple fan
// triangulation that serves as our face occluder. The fan from a computed
// centroid produces 36 triangles, which is more than enough to occlude
// goggle temples behind the cheeks during head rotation.
//
// In Phase 2 we'll upgrade to the full FACEMESH_TESSELATION (~880 triangles)
// for pixel-perfect occlusion. For Phase 1, the oval is the right tradeoff
// between accuracy and code volume.

export const FACEMESH_FACE_OVAL = [
  10, 338, 297, 332, 284, 251, 389, 356,
  454, 323, 361, 288, 397, 365, 379, 378,
  400, 377, 152, 148, 176, 149, 150, 136,
  172, 58, 132, 93, 234, 127, 162, 21,
  54, 103, 67, 109
];

// Eye landmark indices (used to compute pupillary distance and gaze direction).
// Left/right are from the SUBJECT's perspective (not the camera's).
export const LEFT_EYE_CENTER  = 468;   // iris centre
export const RIGHT_EYE_CENTER = 473;   // iris centre
export const LEFT_EYE_OUTER   = 33;
export const LEFT_EYE_INNER   = 133;
export const RIGHT_EYE_INNER  = 362;
export const RIGHT_EYE_OUTER  = 263;

// Nose bridge — the canonical glasses-resting point.
export const NOSE_BRIDGE_TOP   = 168;
export const NOSE_BRIDGE_MID   = 6;
export const NOSE_TIP          = 1;

// Face width references — used for iris-based scale calibration.
export const FACE_LEFT_TEMPLE  = 234;
export const FACE_RIGHT_TEMPLE = 454;

// The physical diameter of the human iris is remarkably consistent across the
// population at ~11.7 mm. This is the basis for converting MediaPipe's metric
// space to real millimetres for PD measurement and frame sizing.
export const IRIS_DIAMETER_MM = 11.7;
